import type { RegionCode } from 'google-libphonenumber';
import { useMemo } from 'react';
import { getFormattedExampleNumber } from '../../services/phoneNumber.service';

interface UseExamplePhoneNum {
  isoCode: RegionCode;
}
export const useExamplePhoneNum = ({ isoCode }: UseExamplePhoneNum) =>
  useMemo(() => getFormattedExampleNumber(isoCode), [isoCode]);
